import {
  AGREEMENT_TYPE,
  IAgreementTemplatetAggregator,
  IAgreementTemplatetAggregatorForm,
} from 'services/templates/agreement-template/types';

export const agreementTemplateFormToQuery = (
  agreement: IAgreementTemplatetAggregatorForm,
  position = 0,
  update = true
): IAgreementTemplatetAggregator => {
  const { selectAgreementTemplate, textAgreementTemplate, type } = agreement;

  const agreementDefaultParoperties = { position, update, mode: 1 };

  if (type === AGREEMENT_TYPE.text && textAgreementTemplate) {
    return {
      selectAgreementTemplate: null,
      textAgreementTemplate: {
        ...textAgreementTemplate,
        ...agreementDefaultParoperties,
      },
    };
  }
  if (type === AGREEMENT_TYPE.select && selectAgreementTemplate) {
    return {
      textAgreementTemplate: null,
      selectAgreementTemplate: {
        ...selectAgreementTemplate,
        ...agreementDefaultParoperties,
      },
    };
  }

  return {
    textAgreementTemplate: null,
    selectAgreementTemplate: null,
  };
};
